export default __webpack_public_path__ + "static/media/taigh.31ae9f9b.mp3";